import React from 'react'

// Ловит ошибки рендера дочернего дерева, чтобы одна «битая» карточка заказа
// не роняла весь интерфейс в белый экран. Когда меняется resetKey
// (пришли новые/обновлённые данные) — сбрасывается и пробует отрендерить снова,
// поэтому восстановление происходит само, без перезагрузки страницы.
class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught', error, info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null
    }
    return this.props.children
  }
}

export default ErrorBoundary
